/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Pages_Back_To_HomeInputs */

const en_common_pages_back_to_home = /** @type {(inputs: Common_Pages_Back_To_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to home`)
};

/**
* | output |
* | --- |
* | "Back to home" |
*
* @param {Common_Pages_Back_To_HomeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_pages_back_to_home = /** @type {((inputs?: Common_Pages_Back_To_HomeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Pages_Back_To_HomeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_pages_back_to_home(inputs)
});
export { common_pages_back_to_home as "common.pages.back_to_home" }